module.exports = __webpack_public_path__ + "static/media/mini-logo.5bd35c5d.svg";